module.exports = __webpack_public_path__ + "843236b232dd2f71ba00fdcb20a88f47.pdf";